export enum HeaderFields {
	Worker = 'Worker',
	Client = 'Client',
	Site = 'Site',
	Status = 'Status',
	WeekEnding = 'Week Ending',
}
